<section class="dashboard">
  <div class="dashboard-header">
    <div class="user-info">
      <img [src]="user.picture" alt="user avatar" class="avatar" />
      <div>
        <h2>{{ user.nickname }}</h2>
        <p>{{ user.email }}</p>
      </div>
    </div>
    <div class="settings">
      <button class="icon-btn"><i class="ph ph-gear"></i></button>
    </div>
  </div>

  <div class="insights-header">
    <div class="title-group">
      <h3>User Manager</h3>
      <p>Invite, view, and manage users with access to your account</p>
    </div>
    <div class="actions">
      <button class="new-btn" (click)="addUser()">Invite User</button>
    </div>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <h3>Total Users</h3>
      <p class="value">{{ users.length }}</p>
    </div>
    <div class="stat-card">
      <h3>Admins</h3>
      <p class="value">{{ adminCount }}</p>
    </div>
    <div class="stat-card">
      <h3>Clients</h3>
      <p class="value">{{ clientCount }}</p>
    </div>
  </div>

  <app-admin-grid
    title="Users"
    [entityLabel]="'User'"
    [columns]="columns"
    [data]="users"
    (addClicked)="addUser()"
    (editClicked)="editRole($event)"
    (deleteClicked)="deleteUser($event)">
  </app-admin-grid>

  <!-- Invite Modal -->
  <div class="modal-backdrop" *ngIf="showInviteModal">
    <div class="modal">
      <h3>Invite New User</h3>

      <form (ngSubmit)="sendInvite()" #inviteForm="ngForm">
        <div class="form-group">
          <label for="inviteName">Name</label>
          <input
            id="inviteName"
            type="text"
            [(ngModel)]="inviteName"
            name="inviteName"
            placeholder="Enter full name"
          />
        </div>

        <div class="form-group">
          <label for="inviteEmail">Email</label>
          <input
            id="inviteEmail"
            type="email"
            [(ngModel)]="inviteEmail"
            name="inviteEmail"
            required
            placeholder="Enter email address"
          />
        </div>

        <div class="form-group">
          <label for="inviteRole">Role</label>
          <select
            id="inviteRole"
            [(ngModel)]="inviteRole"
            name="inviteRole"
          >
            <option value="client">Client</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div class="modal-actions">
          <button type="submit" class="primary-btn" [disabled]="loading">
            {{ loading ? 'Sending...' : 'Send Invite' }}
          </button>
          <button type="button" class="cancel-btn" (click)="cancelInvite()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</section>
